import { useCallback } from "react"
import { AdvantagesSection } from "../components/AdvantagesSection"
import { AudienceSection } from "../components/AudienceSection"
import { ContactSection } from "../components/ContactSection"
import { FaqSection } from "../components/FaqSection"
import { FeaturesSection } from "../components/FeaturesSection"
import { Footer } from "../components/Footer"
import { Header } from "../components/Header"
import { Hero } from "../components/Hero"
import { HowItWorksSection } from "../components/HowItWorksSection"
import { SecuritySection } from "../components/SecuritySection"
import { TestimonialsSection } from "../components/TestimonialsSection"
import { redirectToLogin } from "../lib/loginNavigation"

export const LandingPage = () => {
  const handleLogin = useCallback(() => {
    redirectToLogin("/app")
  }, [])

  const handleDemo = useCallback(() => {
    document.getElementById("contato")?.scrollIntoView({ behavior: "smooth" })
  }, [])

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Hero onPrimaryCta={handleDemo} onLogin={handleLogin} />
        <FeaturesSection />
        <AdvantagesSection />
        <HowItWorksSection />
        <AudienceSection />
        <SecuritySection />
        <FaqSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  )
}
